<template>
  <iColumn
    width="fill"
    height="hug"
    gap="extraSmall"
    align="left"
  >
    <iUploader
      :acceptable-file-types="acceptableFileTypes"
      @upload-file="uploadFile"
    >
      <ContainerProduction
        v-bind="containerProps"
        :style-overrides="uploadStyleOverrides"
        @dragenter="onDragEnter"
        @dragover="onDragOver"
        @dragleave="onDragLeave"
        @drop="onDrop"
      >
        <slot />
      </ContainerProduction>
    </iUploader>
    <iText v-if="uploadError" variant="error" font-size="small">
      {{ uploadError }}
    </iText>
  </iColumn>
</template>

<script>
import ContainerProduction from "%/dynamic-component-editor/standard-elements/layouts/ContainerProduction.vue";
import { DynamicElementMixin } from "%/dynamic-component-editor/mixins/dynamic-element-mixin";
import DynamicElementWithContext from "%/dynamic-component-editor/mixins/dynamic-element-with-context-mixin";
import FileUploadBehaviour from "%/dynamic-component-editor/standard-elements/file-upload/file-upload-behaviour-mixin";

const UPLOADING_OPACITY = "0.6";
const DRAG_ACTIVE_OPACITY = "0.85";
const MSG_WRONG_TYPE = "That file type is not accepted for this question.";

export default {
  name: "FileUploadContainer",
  components: { ContainerProduction },
  production: true,
  mixins: [DynamicElementMixin, DynamicElementWithContext, FileUploadBehaviour],
  inheritAttrs: false,
  data() {
    return {
      isDragActive: false,
    };
  },
  computed: {
    containerProps() {
      return {
        ...this.$attrs,
        optionValues: this.optionValues,
        activeState: this.activeState,
        identifier: this.identifier,
        themeMode: this.themeMode,
        editMode: this.editMode,
      };
    },
    uploadStyleOverrides() {
      if (this.editMode) {
        return {};
      }
      if (this.isUploading) {
        return { cursor: "progress", opacity: UPLOADING_OPACITY };
      }
      if (this.isDragActive) {
        return { cursor: "copy", opacity: DRAG_ACTIVE_OPACITY };
      }
      return { cursor: "pointer" };
    },
  },
  methods: {
    onDragEnter(event) {
      if (this.editMode) {
        return;
      }
      event.preventDefault();
      this.isDragActive = true;
    },
    onDragOver(event) {
      if (this.editMode) {
        return;
      }
      event.preventDefault();
      this.isDragActive = true;
    },
    onDragLeave(event) {
      if (this.editMode || this.$el?.contains(event.relatedTarget)) {
        return;
      }
      this.isDragActive = false;
    },
    onDrop(event) {
      if (this.editMode) {
        return;
      }
      event.preventDefault();
      this.isDragActive = false;
      const file = Array.from(event.dataTransfer?.files ?? [])[0];
      if (!file) {
        return;
      }
      if (!this.isAcceptableFile(file)) {
        this.uploadError = MSG_WRONG_TYPE;
        return;
      }
      this.uploadError = "";
      this.uploadFile(file);
    },
    isAcceptableFile(file) {
      if (!this.acceptableFileTypes.length) {
        return true;
      }
      const mimeType = file.type || "";
      const name = (file.name || "").toLowerCase();
      return this.acceptableFileTypes.some(pattern => {
        if (pattern.startsWith(".")) {
          return name.endsWith(pattern.toLowerCase());
        }
        if (pattern.endsWith("/*")) {
          return mimeType.startsWith(pattern.slice(0, -1));
        }
        return mimeType === pattern;
      });
    },
  },
};
</script>
